import { ApiResponseType, BillingCurrentPlanType, BillingSubscriptionType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';
import { BillingPlanScheduleType, SubscriptionPlanType } from '@/const/shared';

export type InternalOrganizationBillingCurrentPlanType = BillingCurrentPlanType & {
  interval_price_amount: number;
  currency: string;
  schedule_type: BillingPlanScheduleType;
};

export type InternalOrganizationBillingSubscriptionType = Omit<BillingSubscriptionType, 'current_period_start'> & {
  date_started: string;
};

export type InternalOrganizationBillingDetailsType = {
  organization: {
    id: string;
    name: string;
    subscription_plan_type: SubscriptionPlanType;
    active_users_count: number;
  };
  current_plan: InternalOrganizationBillingCurrentPlanType;
  monthly_views_available: number;
  extra_views_available: number;
  extra_views_bought: number;
  subscription: InternalOrganizationBillingSubscriptionType;
};

export const getInternalOrganizationBillingDetailsApi = async (): Promise<
  ApiResponseType<InternalOrganizationBillingDetailsType>
> => {
  const uri = '/organization/internal/billing-profile/';

  return authApiService.GET(uri);
};
